<template>
    <Frame>
      <PageHeader :title="$t('comm.returnDetail')" :hasBack="true" detailType="ReturnQueryDetail" />
      <div class="returnDetail" style="padding:10px;">
        <div class="contain">
          <div class="message" style="width:100%;">
            <ul>
              <li class="messagetitle">{{ $t('comm.messagetitle') }}</li>
              <li class="button option-icon" id="Export" v-if="$store.state.exportExcelDetailState" @click="Export()"> <svg-icon icon-class="export" />{{ $t('button.export') }}</li>
              <li class="button option-icon" id="print" @click="printdialog()"><svg-icon icon-class="print" />{{ $t('button.print') }}</li>
            </ul>
            <ul style="padding:0 20px;display: flex;flex-wrap: wrap;">
              <li class="message">{{ $t('ReturnDetail.billNo') }}:{{ billno }}</li>
              <li class="message">{{ $t('ReturnDetail.billDate') }}：{{ billdate }}</li>
              <li class="message" v-if="$store.state.ShowComp">{{ $t('ReturnDetail.orgName') }}：{{ orgName }}</li>
              <li class="message">{{ $t('ReturnDetail.purchaser') }}：{{ purchaser }}</li>
     
              <li class="message">{{ $t('ReturnDetail.amount') }}：{{ amount }}</li>   
              <li class="message">{{ $t('ReturnDetail.OAmountWithTax') }}：{{ oAmountWithTax }}</li>           

              <li class="message">{{ $t('ReturnDetail.remark') }}：{{ remark }}</li>
            </ul>
          </div>
        </div>
        <ul>
          <li class="messagetitle">{{ $t('comm.returnDetail') }}</li>
        </ul>
        <el-table :data="tableData" :height="tableHeight" v-loading="tableLoading" style="margin:0;width:100%">
          <el-table-column width="50" prop="Number" :label="$t('ReturnDetail.number')"></el-table-column>
          <el-table-column :width="WidthControl('MaterialId',tableData)" prop="MaterialId" :label="$t('ReturnDetail.codeid')"></el-table-column>
          <el-table-column :width="WidthControl('MaterialName',tableData)" prop="MaterialName" :label="$t('ReturnDetail.name')"></el-table-column>
          <el-table-column :width="WidthControl('MaterialSpec',tableData)" prop="MaterialSpec" :label="$t('ReturnDetail.specifications')"></el-table-column>
          <el-table-column prop="ReceivingSQty" :min-width="WidthControl('ReceivingSQty&&SUnitName',tableData)" align="right"
            :label="$t('ReturnDetail.receiptnumber')">
            <template slot-scope="scope">
              <span>{{ scope.row.ReceivingSQty}}&nbsp{{ scope.row.SUnitName }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="$store.state.ShowBasicUnit" prop="ReceivingQty" :min-width="WidthControl('ReceivingQty&&UnitName',tableData,6)" align="right" :label="$t('ReturnDetail.receivingQty')">
            <template slot-scope="scope">
              <span>{{ scope.row.ReceivingQty}}&nbsp{{ scope.row.UnitName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="SQuantity" align="right" :min-width="WidthControl('SQuantity&&SUnitName',tableData)" :label="$t('ReturnDetail.SQuantity')">
            <template slot-scope="scope">
              <span>{{ scope.row.SQuantity}}&nbsp{{ scope.row.SUnitName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="PresentSQty" align="right" :min-width="WidthControl('PresentSQty&&SUnitName',tableData)" :label="$t('ReturnDetail.presentSQty')">
            <template slot-scope="scope">
              <span v-if="scope.row.PresentSQty && scope.row.PresentSQty!=''">{{ scope.row.PresentSQty}}&nbsp{{ scope.row.SUnitName }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="120" prop="SPrice" align="right" :label="$t('ReturnDetail.price')"></el-table-column>
          <el-table-column min-width="120" prop="strPrice" align="right" :label="$t('ReturnDetail.subtotal')"></el-table-column>
          <el-table-column min-width="120" prop="OAmountWithTax" align="right" :label="$t('ReturnDetail.OAmountWithTax')"></el-table-column>
          <el-table-column :width="WidthControl('BackReasonName',tableData,5)" prop="BackReasonName" :label="$t('ReturnDetail.backReasonName')"></el-table-column>
          <el-table-column v-if="$store.state.ShowMTO" :min-width="WidthControl('MTONo',tableData,5)" prop="MTONo" :label="$t('OrderDetailSearch.txtMTONo')"></el-table-column>
          <el-table-column v-if="$store.state.ShowBatchNo" :min-width="WidthControl('BatchNo',tableData,5)" prop="BatchNo" :label="$t('OrderDetailSearch.txtBatchNo')"></el-table-column>
          <el-table-column :width="WidthControl('Remark',tableData)" prop="Remark" :label="$t('ReturnDetail.remark')"></el-table-column>
        </el-table>
      </div>
      <DialogPrint :billno="billno" :progId="progId" ref="DialogPrint"></DialogPrint>
    </Frame>
  </template>
  
  <script>
  import SvgIcon from '../components/SvgIcon'
  import DialogPrint from '@/components/DialogPrint.vue';
  export default {
    name: 'ReturnDetail',
    components: { SvgIcon,DialogPrint },
    data() {
      return {
        progId:'purReceivingOrder',
        tableHeight: window.innerHeight - 390,
        billno: '',
        billdate: '',
        oAmountWithTax:'',
        amount: '',
        orgName:'',
        warestate: '',
        warestateclass: 'warestate',
        cancelstate: '',
        cancelstateclass: 'warestate',
        purchaser: '',
        remark: '',
        tableLoading: false,
        pageindex: 0,
        tableData: [],
        BillType:'Return'
      }
    },
    created() {
      this.billno = this.$route.query.DelBillNo;
    },
    mounted() {
      let that = this;
      window.onresize = () => {
        if (that.resizeFlag) {
          clearTimeout(that.resizeFlag);
        }
        that.resizeFlag = setTimeout(() => {
          that.tableHeight = window.innerHeight - 390;
          that.resizeFlag = null;
        }, 100);
      }
      this.tableLoading = true;
      this.getReturnDetail();
    },
  
    methods: {
      getReturnDetail() {
        debugger
        this.axiosInvoke("/SupplierComm/Handler/OrderPurPurchaseHandler.ashx", {
          action: "getorderfahuodetail",
          billno: this.billno,
          isReturnOrder : true
        }, (res) => {
          var data = eval(res.data);
          this.billdate = data.HeadInfo.BillDate;
          this.orgName = data.HeadInfo.OrgName;
          this.amount = data.HeadInfo.OAmount;
          this.oAmountWithTax = data.HeadInfo.OAmountWithTax
          this.purchaser = data.HeadInfo.PersonName;
          this.remark = data.HeadInfo.Remark;
          this.tableData = data.BodyTable;
          this.tableLoading = false;
        })
      },
      Export() {//导出
        let action = 'exportexcel'
        let progId = 'purReceivingOrder'
        //取回当前查询表进行导出
        this.exportExcel(action, progId, this.tableData)
      },
      printdialog(){
          this.$refs.DialogPrint.printdialog();
      }
    }
  }
  </script>
  
  <style scoped>
  ul {
    padding: 0;
  }
  
  .message {
    color: #777777;
    font-size: 14px;
    width: 24%;
    padding-right: 1%;
  }
  
  .message li {
    display: inline-block;
    text-align: left;
  }
  
  .option-icon{
    filter: grayscale(100%);
    margin:0 2.5%;
  }
  .option-icon:hover{
    filter: grayscale(0%);
  }
  .messagetitle {
    color: #5d5d5d;
    font-size: 16px;
    width: 80%;
    padding: 0 20px;
  }
  
  .button {
    color: #5d5d5d;
    font-size: 15px;
    cursor: pointer;
  }
  
  .button:hover {
    cursor: pointer;
    color: #0177d5;
  }
  
  .warestate {
    color: #777777;
  }
  
  .warestatered {
    color: red;
  }
  
  .el-table /deep/ th.el-table__cell {
    background-color: #f9f9f9;
  }
  
  .el-table /deep/ .el-table__body-wrapper {
    font-size: 13px;
  }
  
  .el-table /deep/ thead {
    font-size: 14px;
    color: #777777;
  }
  
  .el-table /deep/ .el-table_1_column_1 .cell:first-child {
    padding: 0 0 0 30px;
  }
  
  .el-table /deep/ .cell:first-child {
    font-weight: normal;
  }
  </style>